<script>
import $ from 'domtastic';
import delay from 'lodash/delay';
import Tooltip from 'tooltip.js';

import mixins from './vueMixins';
import scrollAnimator from './scrollAnimator';
import VsButton from './VsButton';
import VsContainerControls from './VsContainerControls';
import VsInput from './VsInput';
import VsLayout from './VsLayout';
import VsLogoLoader from './VsLogoLoader';
import VsTabs from './VsTabs';

import './stylesheets/components/VsContainer';

export default {
  components: {
    VsLogoLoader,
    VsButton,
    VsTabs,
    VsLayout,
    VsInput,
    VsContainerControls,
  },
  mixins: [mixins],
  props: {
    title: String,
    titleHasHelpIcon: [Boolean, String],
    titleHasHelpIconMobile: [Boolean, String],
    count: Number,
    processing: Boolean,
    buttonIcon: String,
    buttonText: String,
    buttonDisabled: Boolean,
    buttonNotVisible: Boolean, //visibility: hidden;
    buttonHidden: [Boolean, String], //display: none;
    buttonSingleLine: [Boolean, String],
    searchText: String,
    searchPlaceholder: {
      type: String,
      defualt: 'Search',
    },
    hideSearch: String,
    hideDate: String,
    tabs: Array,
    activeTab: String,
    timezone: String,
    message1: String,
    message2: String,
    hideLazyLoader: [String, Boolean],
    tooltip: String,
  },
  data: () => ({
    queryTimeout: null,
    dateClear: true,
  }),
  mounted() {
    this.$_initTooltip();
  },
  beforeDestroy() {
    clearTimeout(this.queryTimeout);

    this.$_destroyTooltip();
  },
  methods: {
    async $_initTooltip() {
      if (this.tooltip && this.$refs.tooltip) {
        await this.$nextTick();

        this.helpTooltip = new Tooltip(this.$refs.tooltip, {
          trigger: 'hover',
          placement: 'left',
          title: this.tooltip,
          html: false,
          container: '#content',
        });
      }
    },
    $_destroyTooltip() {
      if (this.helpTooltip) {
        this.helpTooltip.dispose();
      }
    },
    handleSearch(e) {
      clearTimeout(this.queryTimeout);

      this.queryTimeout = delay(() => {
        scrollAnimator.scrollToTop();

        this.$emit('container-search', e);
      }, 500);
    },
    async changeTab(e) {
      this.$emit('change-tab', e);

      await this.$nextTick();

      this.$_destroyTooltip();

      this.$_initTooltip();
    },
    handleDateChanged(e) {
      scrollAnimator.scrollToTop();

      if (e.start && e.end) {
        this.$refs.controlsContainer.$refs.datePicker.setDate(e.start, e.end);

        this.dateClear = false;
      } else if (!this.dateClear) {
        this.$refs.controlsContainer.$refs.datePicker.clear();

        this.dateClear = true;
      }

      this.$emit('container-date-changed', e);
    },
  },
};
</script>

<template lang='pug'>
.vs-table__container
  vs-layout.vs-table__title-container(no-gutter, vert-align-center-xs, wrap-xs, no-wrap-lg, space-between-lg)

    vs-layout(v-if='title', no-gutter, no-shrink-xs, lg='3', xxl='2')
      h5.vs-table__title
        strong {{title}} {{count >= 0 ? '(' + count + ')' : ''}}
        span.mdi.mdi-help-circle.vs-table__title-help--mobile-hide(
          v-if='titleHasHelpIconMobile',
          ref='tooltip',
          @click='$emit("help")',
        )
        span.mdi.mdi-help-circle.vs-table__title-help(v-if='titleHasHelpIcon', @click='$emit("help")')

    vs-layout(v-if='safeNav(tabs, "length")', no-gutter, grow-lg)
      vs-tabs(
        :tabs='tabs',
        :active-tab='activeTab',
        :disabled='processing',
        @change-tab='changeTab',
      )

    vs-layout.vs-table__messages(v-else-if='message1 && message2', no-gutter, grow-lg, hide-lg-down)
      h6
        strong {{message1}}
      h6 {{message2}}

    vs-layout.vs-table__button(v-if='!buttonHidden', no-gutter, no-shrink-xs, horz-align-right-xs, lg='3', xxl='2')
      vs-button(
        :disabled='buttonDisabled',
        :icon='buttonIcon',
        :text='buttonText',
        :processing='processing',
        :not-visible='buttonNotVisible',
        :single-line-button='buttonSingleLine',
        @click='$emit("container-button-click")',
      )

  vs-container-controls.sticky.top-0.z-10(
    v-show='!hideDate || !hideSearch',
    ref='controlsContainer',
    :search-text='searchText',
    :search-placeholder='searchPlaceholder',
    :hide-search='hideSearch',
    :hide-date='hideDate',
    :timezone='timezone',
    @search='handleSearch',
    @container-date-changed='handleDateChanged',
  )
  slot

  .lazy-progress(v-show='processing && !hideLazyLoader')
    vs-logo-loader
</template>